


import axios from "axios";
import { health_api } from "../../Config";
const { decryptData } = require("../../Framework/Utils/decrypt");
const {encryptData} = require("../../Framework/Utils/encrypt")
 const API_URL = `${health_api}/insurance/v1/health/policy/quote`

const PRODUCT_URL = `${health_api}/insurance/v1/health/policy/product`;

const generateTransactionId = () => {
  const staticTransactionId = "LMV00000";
  let dynamicSequence = Array.from({ length: 8 }, () =>
    Math.floor(Math.random() * 10)
  ).join("");
  let transactionId = staticTransactionId + dynamicSequence;
  console.log(transactionId, "transactionID");
  return transactionId;
};

let generatedHDFCTxnId = generateTransactionId();

export const generatePremium = async (commonPostData) => {
  let userType=localStorage.getItem('userType')
  let data = { ...commonPostData ,userType};
  console.log(data,"dgdgjhdgh")
  let encrytedData=encryptData(data)

  try {
    const res = await axios.post(API_URL, {
      payload: encrytedData
    });
    console.log(res.data,"asdbhjgsjdgjds")
    if (res) {
      const decryptedData = decryptData(res.data); // remove body from here for local only
      console.log(decryptedData,"sjkjdskjk")
      return decryptedData;
    } else {
      return res.data;
    }
  } catch (error) {
    console.error("Error in generatePremium:", error);
  }
};

export const generatePremiumById = async (commonPostData) => {
  let data = { ...commonPostData, generatedHDFCTxnId: generatedHDFCTxnId };
  let encrytedData=encryptData(data)
  try {
    let res = await axios.post(PRODUCT_URL, {payload:encrytedData});
    console.log(res,"shasdj")
    if (res.data) {
      const decryptedData = decryptData(res.data);
      console.log("Decrypted Response:", decryptedData);
      return decryptedData;
    } else {
      return res.data;
    }
  } catch (error) {
    console.error("Error in generatePremiumById:", error);
  }
};
